export default {
  auth: null,
  authHom: null,
  user: null,
  status: {},
  csapi: null,
  csprod: null,
};
